import styled from 'styled-components';

import { H5 } from 'components/typography/Headers';
import { Text1 } from 'components/typography/Texts';
import { LoadingIndicator } from 'components/ui-elements/LoadingIndicator';

const Container = styled.div`
  width: 100%;
  align-items: center;
  justify-content: center;
`;

const DataContainer = styled.div`
  width: 100%;
  height: 80px;
  display: flex;
  flex-direction: row;
  gap: 10px;
  justify-content: center;
  align-items: center;
`;

const Header = styled(Text1)`
  text-align: left;
  margin-bottom: 10px;
`;

const StyledLoadingIndicator = styled(LoadingIndicator)`
  width: 20px;
  height: 20px;
`;

const Image = styled.img<{ $isCircle: boolean }>`
  object-fit: cover;
  width: 80px;
  height: 80px;
  aspect-ratio: 1/1;
  border-radius: ${({ $isCircle }) => ($isCircle ? '40px' : '5px')};
`;

const Name = styled(H5)`
  flex: 1;
  text-align: left;
  overflow: hidden;
  word-break: break-word;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`;

interface Props {
  header: string;
  isCircleImage: boolean;
  content?: { name: string; image: string };
}

const DataDetails = ({ header, isCircleImage, content }: Props) => {
  return (
    <Container>
      <Header>{header}</Header>
      <DataContainer>
        {!content && <StyledLoadingIndicator />}
        {!!content && <Image $isCircle={isCircleImage} src={content.image} />}
        {!!content && <Name>{content.name}</Name>}
      </DataContainer>
    </Container>
  );
};

export default DataDetails;
